import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import AboutUs from '@/components/AboutUs'
import Farm from '@/components/Farm'
import Auto from '@/components/Auto'
import Home from '@/components/Home'
import Personal from '@/components/Personal'
import Life from '@/components/Life'
import Health from '@/components/Health'
import RV from '@/components/RV'
import Financial from '@/components/Financial'
import Additional from '@/components/Additional'
import Employees from '@/components/Employees'
import Business from '@/components/Business'
import Industry from '@/components/Industry'
import Providers from '@/components/Providers'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'SIG',
      component: Index
    },
    {
      path: '/providers(.html)?',
      name: 'Providers',
      component: Providers
    },
    {
      path: '/contact-us(.html)?',
      name: 'Contact Us',
      component: AboutUs
    },
    {
      path: '/farm(.html)?',
      name: 'Farm Insurance',
      component: Farm
    },
    {
      path: '/auto(.html)?',
      name: 'Auto Insurance',
      component: Auto
    },
    {
      path: '/home-insurance(.html)?',
      name: 'Home Insurance',
      component: Home
    },
    {
      path: '/personal(.html)?',
      name: 'Other Personal Insurance',
      component: Personal
    },
    {
      path: '/life(.html)?',
      name: 'Life Insurance',
      component: Life
    },
    {
      path: '/health(.html)?',
      name: 'Health Insurance',
      component: Health
    },
    {
      path: '/rv(.html)?',
      name: 'Recreational Vehicle',
      component: RV
    },
    {
      path: '/financial(.html)?',
      name: 'Financial Services',
      component: Financial
    },
    {
      path: '/additional-insurance(.html)?',
      name: 'Additional Insurance Services',
      component: Additional
    },
    {
      path: '/employees(.html)?',
      name: 'Employees Coverage',
      component: Employees
    },
    {
      path: '/business(.html)?',
      name: 'Commercial Coverage',
      component: Business
    },
    {
      path: '/specific-industries(.html)?',
      name: 'Industry Coverage',
      component: Industry
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js